import React, { useState, useEffect } from "react";
import { Navbar, Container, Button } from "react-bootstrap";
import logoEs from '../../assets/myReportin-canal-de-denuncias.png';
import logoCa from '../../assets/myreportin_catalan_positivo.png';
import logoEu from '../../assets/myreportin_euskera_positivo.png';
import logoGa from '../../assets/myreportin_gallego_positivo.png';
import logoEn from '../../assets/myreportin_ingles_positivo.png';
import logoIt from '../../assets/myreportin_italiano_positivo.png';
import { useNavigate, useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";

import {
  MdAccountCircle,
  MdNotifications,
  MdNotificationsActive,
  MdRocketLaunch,
} from "react-icons/md";

import { GetNotificationsService } from "../../Services/notificationService";
import { FaFileAlt, FaQuestionCircle } from "react-icons/fa";
import VideoPopup from "./videoPopUp";
import LanguageSelector from "./languageSelector";
import CookiesPopup from "./cookiesPopup";
import { PatchUserService } from "../../Services/userService";
// import { GetComapanyService } from "../../Services/companyService";
import { GetComapanyServiceReduced } from "../../Services/companyService";
import UpdateSummaryPopup from "./updateSummaryPopup";


const logos = {
  es: logoEs,
  ca: logoCa,
  eu: logoEu,
  ga: logoGa,
  en: logoEn,
  it: logoIt,
};

const updateManual = 'https://www.myreportin.com/descargas/novedades-Myreportin.pdf';


const helpVideos = {
  es: 'https://player.vimeo.com/video/878615607?h=f904e7c643',
  ca: 'https://player.vimeo.com/video/894529702?h=f904e7c643',
  eu: 'https://player.vimeo.com/video/894527749?h=f904e7c643',
  en: 'https://player.vimeo.com/video/894524576?h=f904e7c643',
  it: 'https://player.vimeo.com/video/960963917?h=f904e7c643',
};

const Header = ({
  privateWeb,
  publicIncident,
  imageMimeType,
  imageData,
  helpVideo,
  companyId,
  manual,
  translucent = false,
  reloadData,
  showUpdate = true
}) => {
  const navigate = useNavigate();

  const [t, i18n] = useTranslation("header");
  const currentLanguage = i18n.language;


  const [showLogOut, setShowLogOut] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [notificationsData, setNotificationsData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const { id } = useParams();
  const authInfoString = localStorage.getItem("authInfo");
  const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
  const role = authInfo.rol;
  const idUser = authInfo.idUser;
  const responsible = authInfo.idUser;
  const email = authInfo.email;

  const [companyLanguages, setCompanyLanguages] = useState(['es', 'ca', 'eu', 'en', 'it']);



  useEffect(() => {
    const fetchData = async () => {
      try {
        if (responsible) {
          const response = await GetNotificationsService(t);

          setNotificationsData(response);
        }

      } catch (error) {
        console.error(
          "Hubo un error al obtener los datos de los usuarios",
          error
        );
      }
    };

    fetchData();



    let languageCookie = Cookies.get('myreportin_language');

    if (!languageCookie) {
      Cookies.set('myreportin_language', 'es', { expires: 730, secure: true, sameSite: 'none', domain: '.myreportin.com' });
      Cookies.set('myreportin_language', 'es', { expires: 730, secure: true, sameSite: 'none' });//LOCALHOST
      // i18n.changeLanguage('es')
    } else {
      i18n.changeLanguage(languageCookie)

    }


  }, []);

  useEffect(() => {

    const getLanguages = async () => {
      if (publicIncident && companyId) {
        const responseLanguages = await GetComapanyServiceReduced(companyId)
        const enabledLanguages = responseLanguages.textCompanies
          .filter(company => company.enabled)
          .map(company => company.language);
        setCompanyLanguages(enabledLanguages);
      }
    };

    getLanguages();


  }, [companyId]);

  const handleLanguageChange = async (language) => {

    Cookies.set('myreportin_language', language.value, { expires: 730, secure: true, sameSite: 'none', domain: '.myreportin.com' });
    Cookies.set('myreportin_language', language.value, { expires: 730, secure: true, sameSite: 'none' });//LOCALHOST
    if (idUser && !translucent) {
      const user = {
        language: language.value
      }
      if(!privateWeb){
        await PatchUserService(user, idUser);
      }
    }
    i18n.changeLanguage(language.value)

    if (reloadData) {
      reloadData(language.value)
    }

    // window.location.reload();
  }

  // Manejador para redirigir al usuario a otra página
  const handleLogoClick = () => {

    if (publicIncident) {
      if (companyId) {
        navigate(`/public/${companyId}`);
      } else {

        navigate(`/public/${id}`);
      }
    } else if (role === 'admin') {
      navigate("/users");
    } else if (role === "responsible") {
      navigate("/incidents");
    }
  };

  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  const handleUserClick = () => {
    setShowLogOut(!showLogOut);
  };

  const handleLogoutClick = () => {
    localStorage.removeItem("authInfo");
    sessionStorage.removeItem("cookiespopuphide");
    navigate("/login");
  };

  const handleManualDownload = () => {
    window.open(manual, '_blank');
  };

  const handleUpdateManualDownload = () => {
    window.open(updateManual, '_blank');
  };

  const handleVideoPopUpClose = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLogOut && !event.target.closest(".header-private-container")) {
        setShowLogOut(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showLogOut]);

  // Comprobar si hay alguna notificación con el estado "Vista"
  const hasViewedNotification = notificationsData.some(
    (notification) => !notification.viewBool
  );

  const companyLogo = `data:${imageMimeType};base64,${imageData}`;
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <>
      <VideoPopup
        show={showPopup}
        title={t("header.videoPopup")}
        url={helpVideos[currentLanguage] || helpVideos['es']}
        handleClose={handleVideoPopUpClose}
      />

      <CookiesPopup />
      {
        showUpdate && !publicIncident &&
        <UpdateSummaryPopup />
      }


      <Navbar className={`w-100 header ${translucent ? 'background-transparent' : ''}`}>
        <div className="flex-container">
          <Navbar.Brand className={`${translucent ? 'opacity-0' : ''}`}>
            <img
              src={privateWeb ? companyLogo : logos[currentLanguage] || logoEs}
              className={privateWeb ? !helpVideo ? "header-logo-2-small" : "header-logo-2" : "header-logo"}
              onClick={handleLogoClick} // Agregar manejador de eventos aquí
              onLoad={() => setImageLoaded(true)}
              style={{
                cursor: "pointer",
                opacity: imageLoaded ? 1 : 0,
                transition: "opacity 0.3s",
              }}
            />
          </Navbar.Brand>

          <div className="header-private-container">
            <div className="mobile-vertical">

              {!privateWeb && showUpdate &&
                <div className="header-help-button-container" >
                  <Button
                    className="header-help-button"
                    size="sm"
                    onClick={() => handleUpdateManualDownload()}
                  >
                    <div className="header-help-button-text">
                      <MdRocketLaunch size={15} className="header-help-button-icon-mobile" />
                      <span className="ms-1 header-help-button-span">{t("header.updateManual")}</span>
                    </div>
                  </Button>
                </div>
              }

              {manual ? (

                <div className="header-help-button-container" >
                  <Button
                    className="header-help-button"
                    size="sm"
                    onClick={() => handleManualDownload()}
                  >
                    <div className="header-help-button-text">
                      <FaFileAlt size={15} className=" header-help-button-icon-mobile" />
                      <span className="ms-1 header-help-button-span">{t("header.manual")}</span>
                    </div>
                  </Button>
                </div>
              ) : null}

              {helpVideo ? (

                <div className="header-help-button-container">
                  <Button
                    className="header-help-button"
                    size="sm"
                    onClick={() => setShowPopup(true)}
                  >
                    <div className="header-help-button-text">
                      <FaQuestionCircle size={15} className="header-help-button-icon-mobile" />
                      <span className="ms-1 header-help-button-span">{t("header.helpVideo")}</span>
                    </div>
                  </Button>
                </div>
              ) : null}
            </div>

            <LanguageSelector onChange={handleLanguageChange} grayBackground={translucent} availableLanguages={companyLanguages} key={companyLanguages} />
            {privateWeb || translucent ? <div className="margin-right-3" /> : null}

            {!privateWeb && !translucent && (
              <div className="header-private-container ms-4">
                {role === "responsible" || role === "adminResponsible" ? (
                  hasViewedNotification ? (
                    <span className="custom-shadow-bold header-bell-icon-container">
                      <MdNotificationsActive
                        className="header-bell-icon header-bell-icon-active"
                        size={30}
                        onClick={handleNotificationClick}
                      />
                    </span>
                  ) : (
                    <MdNotifications
                      className="header-bell-icon"
                      size={35}
                      onClick={handleNotificationClick}
                    />
                  )
                ) : null}

                {!translucent ? <>
                  <MdAccountCircle
                    className={`header-user-icon custom-shadow`}
                    size={40}
                    onClick={() => {
                      handleUserClick();
                    }}
                    onMouseEnter={() => {
                      setTimeout(() => {
                        setShowEmail(true);
                      }, 500);
                    }}
                    onMouseLeave={() => setShowEmail(false)}
                  />

                  {showLogOut && (
                    <div className="header-logout-button-container">
                      <Button
                        className="header-logout-button"
                        size="sm"
                        onClick={handleLogoutClick}
                      >
                        {t("header.logOut")}
                      </Button>
                    </div>
                  )}

                  {!showLogOut && showEmail && (
                    <span className="header-user-text me-2 text-bold ">{email}</span>
                  )}
                </>
                  :
                  ''}

              </div>
            )}
          </div>
        </div>
      </Navbar>
    </>
  );
};

export default Header;
